import type { ConfigBundle } from "@tracking-web/shared";

/**
 * Descarga el config bundle (reglas + variantes) desde el endpoint cacheable.
 * El origen del SDK se deduce de la URL del propio <script> para no hardcodear
 * el dominio (clave para el modelo SaaS: el snippet apunta al dominio del servicio).
 */
/** Localiza el <script> del SDK: currentScript si está, si no por atributo/src. */
export function findScript(): HTMLScriptElement | null {
  const current = document.currentScript as HTMLScriptElement | null;
  if (current?.src) return current;
  return (
    document.querySelector<HTMLScriptElement>("script[data-site-key]") ||
    document.querySelector<HTMLScriptElement>('script[src*="sdk.js"]')
  );
}

export function resolveOrigin(): string {
  const src = findScript()?.src;
  if (src) {
    try {
      return new URL(src).origin;
    } catch {
      /* noop */
    }
  }
  return window.location.origin;
}

export async function fetchConfig(origin: string, siteKey: string): Promise<ConfigBundle | null> {
  try {
    const res = await fetch(`${origin}/api/config/${encodeURIComponent(siteKey)}`, {
      method: "GET",
      credentials: "omit",
      mode: "cors",
    });
    if (!res.ok) return null;
    return (await res.json()) as ConfigBundle;
  } catch {
    return null;
  }
}
